/**
 * Gets the mobile layout breakpoint.
 *
 * @returns The pixel width below which the mobile layout applies.
 */
export function getMobileCutoff() {
	return 1064;
}

/**
 * Checks whether the current page is the cart page.
 *
 * @returns Whether the current page is the cart page.
 */
function isCartPage(): boolean {
	return document.querySelector("#exto-cart") !== null;
}

/**
 * Checks whether the current page is a category page.
 *
 * @returns Whether the current page is a category page.
 */
function isCategoryPage(): boolean {
	return document.querySelector(".exto-category-filters") !== null;
}

/**
 * Checks whether the current page is a product page.
 *
 * @returns Whether the current page is a product page.
 */
function isProductPage(): boolean {
	return document.querySelector(".extendo .exto-container") !== null;
}

if (isProductPage()) {
	import("./front/product-page/ProductPage").then((e) => {
		new e.default().loadModules();
	});
}

if (isCategoryPage()) {
	import("./front/category-page/CategoryPage").then((e) => {
		e.default();
	});
}

if (isCartPage()) {
	import("./front/cart-page/CartPage").then((e) => new e.default());
}
